const ownerSecretKey = (publicId: string) => `tpe.practice-visibility.owner.${publicId}`;

/**
 * The server issues an HttpOnly owner cookie for a scan. This session-scoped
 * fallback keeps the same opaque capability in the initiating browser tab when
 * a staging proxy fails to forward Set-Cookie. It is never added to a URL.
 */
export function storePracticeVisibilityOwnerSecret(publicId: string, ownerSecret: string) {
  if (typeof window === "undefined") return;
  window.sessionStorage.setItem(ownerSecretKey(publicId), ownerSecret);
}

export function getPracticeVisibilityOwnerSecret(publicId: string) {
  if (typeof window === "undefined" || !publicId) return undefined;
  return window.sessionStorage.getItem(ownerSecretKey(publicId)) ?? undefined;
}

export function clearPracticeVisibilityOwnerSecret(publicId: string) {
  if (typeof window === "undefined" || !publicId) return;
  window.sessionStorage.removeItem(ownerSecretKey(publicId));
}
